import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { ReactSVG } from "react-svg";
import Pagination from "@mui/material/Pagination";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import {
  massege,
  search_icon,
  student_grade_flage,
  srot,
} from "../assets/images/images";
import { useCourseContext } from "../context/CourseContext";
import Helper from "../utils/Helper";
import { Button } from "@mui/material";
import api from "../api/api";
import { useAuth } from "../features/auth/AuthContext";
import SortPopup from "../pages/customSort/SortPopup";
import FilterPopup from "../pages/customFilter/FilterPopup";
import BackButton from "./BackButton/BackButton";
import LoadingComponent from "./LoadingComponent/LoadingComponent";
import {
  convertSecondsToMinutes,
  timeDifferenceInMinutes,
  formatTime,
  addFormattedTime,
} from "../utils/utlis";
import QuestionNew from "../pages/home/components/questions/Question_new";
import "./AssignmentViewProgress.css";
import { getEditGrading, resetGrading } from "../../src/state/actions/editGradingAction";
import { useDispatch, useSelector } from "react-redux";
import { getAllCourseListByTeacher } from "../state/actions/getAllCourseListByTeacherAction";
import { updateGlobalState } from "../state/global/slice";

const AssignmentViewProgress = ({ selectedAssignment, assignmentList, courseType }) => {
  const { loading, error, errormsg, filter_data } = useCourseContext(
    selectedAssignment
  );

  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();


  const [TempglobalState, setTempglobalState] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [search, setSearch] = useState("");
  const [analyticHeadData, setAnalyticHeadData] = useState([]);
  const [headerData, setheaderData] = useState({});
  const [showDropdown, setShowDropdown] = useState(false); // State to control visibility
  const [analyticDetailsData, setAnalyticDetailsData] = useState({});
  let { course_id, analytic_id } = useParams();

  const student_id = location.state?.student?.student_id ?? analytic_id;
  // const assignmentId = location.state?.student?.assignment_id ?? assignment_id;
  const [isLoading, setisLoading] = useState(false);
  const [totalTimeTaken, settotalTimeTaken] = useState("");
  const [maxTimeTakenMinutes, setmaxTimeTakenMinutes] = useState(0);
  const [maxTimeTakenSeconds, setmaxTimeTakenSeconds] = useState(0);
  const fillterstatus = [
    // { id: "Pending", name: "Pending" },
    { id: "Completed", name: "Completed" },
    { id: "In-progress", name: "In progress" },
    // { id: "Overdue", name: "Overdue" },
  ];

  const fillterScore = [
    // { id: 1, name: "A+" },
    // { id: 2, name: "A" },
    // { id: 3, name: "A-" },
    // { id: 4, name: "B+" },
    // { id: 5, name: "B" },
    // { id: 6, name: "B-" },
    // { id: 7, name: "C+" },
    // { id: 8, name: "C" },
    // { id: 9, name: "C-" },
    // { id: 10, name: "D+" },
    // { id: 11, name: "D" },
    // { id: 12, name: "D-" },
    // { id: 13, name: "F" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const inial_value = (currentPage - 1) * itemsPerPage;
  const [isVisible, setIsVisible] = useState(false);
  const [isVisiblefillter, setIsVisiblefillter] = useState(false);
  const [sortValue, setSortValue] = useState(null);
  const [assignmentStatus, setAssignmentStatus] = useState("");
  const [score, setScore] = useState("");
  const [student_assignment_details, setStudent_assignment_details] = useState(
    []
  );
  const type = location?.state?.course?.type
  const globalState = useSelector((state) => state.globalState);
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };


  const getAssignmentList = async (assignment_id) => {
    await api
      .get(`assignments/get-assignment/${assignment_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        // if (response.data.status === 200) {
        // }
      })
      .catch((error) => { });
  };

  const [sortOption, setSortOption] = useState("Newest");
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch(value);
  };
  const handleAssignmentStatusChange = (event) => {
    setAssignmentStatus(event.target.value);
  };

  const handleScoreChange = (event) => {
    setScore(event.target.value);
  };

  // const [loading, setLoading] = useState(false); // Add this state to your component
  const changeSubjectFillter = (event) => {
    const selectedSubject = event.target.value;
    setTempglobalState(selectedSubject);
  };
  const hedleKeyupChnage = async (page, sort) => {

    try {
      const endpoint =
        (courseType === 1 || type === 1)
          ? `assignments/assignmentresultsearch/V2/`
          : `/competitive/assignments/assignmentresultsearch/V2/`;

      // loading = true; // Set loading to true before the request
      const pageNumber = typeof page === "number" ? page : 1;
      const response = await api.get(endpoint, {
        params: {
          page: pageNumber,
          // assignment_id: location?.state?.assignment?.assignment_id,
          assignment_id: selectedAssignment.id,
          student__name: search,
          grade: score,
          result: assignmentStatus,
          sorting: sort || sortOption || 'Newest',
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });

      if (response.status == 200) {
        setStudent_assignment_details(response.data.data);
        setTotalPages(
          response.data.count >= 5
            ? Math.ceil(response.data.count / itemsPerPage)
            : Math.floor(response.data.count / itemsPerPage)
        ); // Calculate total pages
        setNextUrl(response.data.next); // Update next URL
        setPrevUrl(response.data.previous); // Update previous URL
        setIsVisible(false);
        setIsVisiblefillter(false);
      }
    } catch (error) {
    } finally {
      // loading = false;// Set loading to false after the request is completed or if an error occurs
    }
  };

  const [showdownlodefile, setShowdownlodefile] = useState(false); // State to control visibility
  const [fileNameError, setFileNameError] = useState("");
  const [fileNameDownload, setFileNameDownload] = useState("");
  const toggledownlodefile = () => {
    setFileNameDownload("");
    setFileNameError("");
    setShowdownlodefile(!showdownlodefile); // Toggle the visibility state
  };

  const downloadFile = async () => {
    try {
      const response = await api.get(
        `assignments/excel-download-progress/` + selectedAssignment.id + `/`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
          responseType: "blob", // This instructs Axios to handle the response as a Blob
        }
      );
      return response.data; // This should already be a Blob
    } catch (error) {
      throw error;
    }
  };
  const handleFileNameChange = (e) => {
    const enteredValue = e.target.value.trim();
    setFileNameDownload(enteredValue);
    if (!enteredValue) {
      setFileNameError("Please enter file name");
    } else {
      setFileNameError("");
    }
  };
  const triggerDownload = (blob, fileNameDownload) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = fileNameDownload + ".xlsx"; // Set the default file name for the download
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };

  const download_as_excel = async () => {
    if (fileNameDownload === null || fileNameDownload === "") {
      setFileNameError("Please enter file name");
    } else {
      try {
        const fileBlob = await downloadFile();
        triggerDownload(fileBlob, fileNameDownload);
      } catch (error) {
      }
    }
  };
  useEffect(() => {
    if (selectedAssignment.id !== null) {
      AOS.init({
        duration: 500,
      });

      hedleKeyupChnage(currentPage, sortValue);
    }
  }, [currentPage, TempglobalState, search, selectedAssignment]);


  // Function to handle page change
  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const handleSortOptionChange = (newSortOption) => {
    setSortOption(newSortOption);
  };

  const handleApplyClick = () => {
    setCurrentPage(1)
    hedleKeyupChnage(1, sortValue);
    // onApplySort(sortOption);
    // setIsVisible(false);
  };
  const handleSortClick = (sortValue) => {
    setCurrentPage(1)
    setSortValue(sortValue)
    hedleKeyupChnage(1, sortValue);
  };

  // filterDropdownRef start
  const filterDropdownRef = useRef(null);
  useEffect(() => {
    const handleFilterClick = (event) => {
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setIsVisiblefillter(false);
      }
    };

    document.addEventListener("click", handleFilterClick);

    return () => {
      document.removeEventListener("click", handleFilterClick);
    };
  }, []);
  // filterDropdownRef end

  // sortDropdownRef start
  const sortDropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sortDropdownRef.current &&
        !sortDropdownRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // sortDropdownRef end

  const getcompletedTimer = (submission_data, start_time) => {
    const timeTakenArray = submission_data[0]
      ? submission_data[0]?.map((question) => question.time_taken)
      : "";
    const lasttimeinsec = timeTakenArray[timeTakenArray?.length - 1];

    return addFormattedTime(start_time, formatTime(lasttimeinsec));
  };

  const [errorData, setErrorData] = useState({
    error: false,
    errormsg: "",
  });

  const [
    assignmentcompletedDuration,
    setAssignmentcompletedDuration,
  ] = useState("");

  const toggleDropdown = async (index = 0, array = 0, assignment) => {
    await getAssignmentAnalytics(assignment); // Wait until analytics are fetched
    const course_list = globalState.course_list?.filter(
      (course) => course.course_id !== Number(course_id),
    );
    updateState("course_list", course_list);
    dispatch(getAllCourseListByTeacher(teacher_id, token));
    setAssignmentIndex(0);
    setViewAssignmentIndex(index);
    setArrayIndex(array);
    setShowDropdown(true); // Trigger the dropdown display only after fetching
  };

  const toggleDropdownclose = () => {
    setShowDropdown(false);
  };

  const getAssignmentAnalytics = async (assignment) => {
    setisLoading(true);
    try {

      // const apiEndpoint = assignment.is_practice_assignment
      // ? `/assignments/get-practice-assignment-submission/?student_id=${assignment.student_id}&practice_assignment_id=${assignment.practice_assignment_id}`
      // : `/assignments/submissions/?student_id=${assignment.student_id}&assignment_id=${selectedAssignment?.id}`;

      let apiEndpoint = "";

      if (courseType === 1 || type === 1) {
        // Regular course
        apiEndpoint = assignment.is_practice_assignment
          ? `/assignments/get-practice-assignment-submission/?student_id=${assignment.student_id}&practice_assignment_id=${assignment.practice_assignment_id}`
          : `/assignments/submissions/?student_id=${assignment.student_id}&assignment_id=${selectedAssignment?.id}`;
      } else {
        // Competitive course
        apiEndpoint = assignment.is_practice_assignment
          ? `/competitive/assignments/get-practice-assignment-submission/?student_id=${assignment.student_id}&practice_assignment_id=${assignment.practice_assignment_id}`
          : `/competitive/assignments/submissions/?student_id=${assignment.student_id}&assignment_id=${selectedAssignment?.id}`;
      }


      const response = await api.get(apiEndpoint,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setAnalyticDetailsData(response.data?.data);
        setAnalyticHeadData(response.data?.data?.assignment_analytics);

        const completedAssignment = response.data?.data?.assignment_analytics.find(
          (item) => item.status === "Completed"
        );
        if (completedAssignment) {
          setheaderData(completedAssignment);
        }
        setShowDropdown(true); // Show dropdown after data is fetched
      } else {
        setErrorData({ error: true, errormsg: "No Record Found" });
      }
    } catch (error) {
      setErrorData({ error: true, errormsg: error.message });
    } finally {
      setisLoading(false);
    }
  };

  const [assignmentIndex, setAssignmentIndex] = useState(0);
  const [viewAssignmentIndex, setViewAssignmentIndex] = useState(0);
  const [arrayIndex, setArrayIndex] = useState(0);

  useEffect(() => {
    if (student_assignment_details && (student_assignment_details.length > 0)) {
      setStudent_assignment_details((prevData) => {
        const updatedData = [...prevData];

        updatedData[viewAssignmentIndex].marks_awarded = analyticDetailsData?.marks_awarded
        return updatedData;
      });
    }

  }, [analyticDetailsData, viewAssignmentIndex])

  // Helper to determine if assignment type is MCQ or True/False
  const isAutoGradedType = (type) => ["MCQ", "True/False", "TF"].includes(type);

  // Helper to calculate score for auto-graded types
  const getAutoGradedScore = (studentAnswer, correctOption, totalMarks) => {
    return (correctOption === null) ? null : (studentAnswer === correctOption) ? totalMarks : 0
  };

  // Helper to update evaluation for auto-graded types
  const updateAutoGradedEvaluation = (updatedData, assignmentIndex, option) => {
    const question = updatedData.student_answers_json[assignmentIndex];
    const evalQuestion = updatedData.ai_evaluation_json.questions[assignmentIndex];
    const isCorrect = question.student_answer === option;

    if (isCorrect) {
      if (evalQuestion.evaluation !== 'Correct') {
        updatedData.marks_awarded += evalQuestion.marks;
      }
      evalQuestion.marks_obtained = evalQuestion.marks;
      evalQuestion.evaluation = "Correct";
    } else {
      if (evalQuestion.evaluation !== 'Incorrect') {
        updatedData.marks_awarded -= evalQuestion.marks;
      }
      evalQuestion.marks_obtained = 0;
      evalQuestion.evaluation = "Incorrect";
    }
  };

  // Helper to update evaluation for manually graded types
  const updateManualGradedEvaluation = (updatedData, assignmentIndex, getTeacherScore) => {
    const evalQuestion = updatedData.ai_evaluation_json.questions[assignmentIndex];
    const marksDiff = getTeacherScore - evalQuestion.marks_obtained;

    if (marksDiff < 0) {
      updatedData.marks_awarded -= Math.abs(marksDiff);
    } else {
      updatedData.marks_awarded += marksDiff;
    }

    if (getTeacherScore == 0) {
      evalQuestion.evaluation = 'Incorrect';
    } else if (getTeacherScore == evalQuestion.marks) {
      evalQuestion.evaluation = 'Correct';
    } else {
      evalQuestion.evaluation = 'Partial Credit';
    }
    evalQuestion.marks_obtained = getTeacherScore;
  };

  const handleGetTeacherAnswerAssignmentAnalytics = (option, feedbackText, assignmentType, getTeacherScore, saveStatues) => {
    // Prepare data for dispatch
    const question = analyticDetailsData?.student_answers_json[assignmentIndex];
    const evalQuestion = analyticDetailsData?.ai_evaluation_json?.questions[assignmentIndex];
    const score = getTeacherScore
      ? getTeacherScore
      : isAutoGradedType(assignmentType)
        ? getAutoGradedScore(question.student_answer, option, evalQuestion.marks)
        : null;

    const data = {
      submission_id: analyticDetailsData?.submission_id,
      assignment_id: analyticDetailsData?.assignment,
      question_id: question?.question_id,
      score,
      ai_feedback: feedbackText ? (feedbackText !== evalQuestion?.ai_feedback) ? feedbackText.replace(/\s+/g, ' ').trim() : null : null,
      student_id: analyticDetailsData?.student,
      ai_answer: option || evalQuestion?.ai_answer || "",
      update_all: saveStatues === 'Save-For-Student' ? false : true
    };

    dispatch(getEditGrading(data, token));

    setAnalyticDetailsData((prevData) => {
      const updatedData = { ...prevData };

      // Update ai_answer if provided
      if (option) {
        updatedData.student_answers_json[assignmentIndex].ai_answer = option;
      }

      // Update ai_feedback if provided
      if (feedbackText) {
        updatedData.ai_evaluation_json.questions[assignmentIndex].ai_feedback = feedbackText;
      }

      // Update evaluation and marks
      if (isAutoGradedType(assignmentType)) {
        updateAutoGradedEvaluation(updatedData, assignmentIndex, option);
      } else if (getTeacherScore) {
        updateManualGradedEvaluation(updatedData, assignmentIndex, getTeacherScore);
      }

      return updatedData;
    });
  };
  const accessControl = location?.state?.accessControl;
  const UserRoleRights = location?.state?.UserRoleRights;
  const allCourses = useSelector(
    (state) => state?.getAllCourseListByTeacher?.courses,
  );
  const TeacherMyCourse = allCourses?.some(
    (course) => Number(course?.course_id) === Number(course_id),
  );
  return (
    <>
      <div id="AssignmentViewProgress-section">
        <div className="view-course-Details-wrapper">
          <div className="LessonViewProgress-header-section">
            <div className="view-course-Details-back-btn-folder LessonViewProgress-back-btn-folder">
              <BackButton
                buttonName={`Current Assignment : ${location?.state?.assignment?.name}`}
              />
              {/* <BackButton buttonName={`Current Assignment : ${selectedAssignment.name}`} /> */}
              {/* <span style={{ fontWeight: "600", width: "100%", textAlign: "center" }}>Current Assignment : {location?.state?.assignment?.name}</span> */}
              {/* <BackButton buttonName={`Current Assignment : ${location?.state?.assignment?.name}`} /> */}
              {/* <i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left"></i> */}
              {/* <h2> Assignment<span>01</span> : Neuroscience Quiz
              </div>Current Assignment : {location?.state?.assignment?.name} */}
              {/* </h2> */}
            </div>
            <div className="date-inner-wrapper">
              <div className="view-course-details-container">
                <div className="view-Students-course-details-folder LessonViewProgress-student-course-folder">
                  <span>Created</span>
                  <div className="view-Students-course-details-counts">
                    <p>
                      {/* {
                        Helper.formatDateTime(
                          selectedAssignment.start_date ? selectedAssignment.start_date : location?.state?.assignment?.start_date
                        ).date
                      } */}
                      {
                        Helper.formatDateTimeToLocal(
                          location?.state?.assignment?.start_date
                        ).date
                      }
                    </p>
                  </div>
                </div>
                <div className="view-Students-course-details-folder LessonViewProgress-student-course-folder">
                  <span>Due date</span>
                  <div className="view-Students-course-details-counts">
                    <p>
                      {/* {
                        Helper.formatDateTime(
                          // student_assignment_details.length > 0 ? student_assignment_details  
                          selectedAssignment.end_date ? selectedAssignment.end_date : location?.state?.assignment?.end_date
                        ).date
                      } */}
                      {
                        Helper.formatDateTimeToLocal(
                          location?.state?.assignment?.end_date
                        ).date
                      }
                    </p>
                  </div>
                </div>
              </div>
              <button type="button">Preview Assignment</button>
            </div>
          </div>
          <div className="LessonViewProgress-tab-folder-container">
            <div className="LessonViewProgress-serach-filter">
              <ReactSVG className="search-icon" src={search_icon} />
              <input
                type="text"
                name="search"
                value={search}
                onChange={handleInputChange}
                onKeyUp={hedleKeyupChnage}
                placeholder="Search by student name"
              />
            </div>
            <div className="LessonViewProgress-tab-filter-wrapper">
              {/* <div
                className="LessonViewProgress-tab-filter-downlode-folder"
                onClick={toggledownlodefile}
              >
                <span>
                  <i className="fa-solid fa-download"></i>
                </span>
              </div> */}

              <div
                className={`LessonViewProgress-tab-filter-downlode-folder ${student_assignment_details.length === 0 ? 'disabled' : ''}`}
                onClick={student_assignment_details.length === 0 ? null : toggledownlodefile}
                style={{
                  cursor: student_assignment_details.length === 0 ? 'not-allowed' : 'pointer',
                  opacity: student_assignment_details.length === 0 ? 0.5 : 1,
                }}
              >
                <Tooltip title={student_assignment_details.length === 0 ? "No assignment found" : ""} arrow>
                  <span>
                    <i className="fa-solid fa-download"></i>
                  </span>
                </Tooltip>
              </div>

              <div className="LessonViewProgress-filder-tab-wrapper">
                <div
                  className="AssignmentViewProgress-filter-popup-wrapper"
                  ref={filterDropdownRef}
                >
                  <div
                    className="lessonviewprogress-filder-tab"
                    onClick={() => {
                      if (!isVisiblefillter) {
                        setIsVisiblefillter(true);
                        setIsVisible(false);
                      } else {
                        setIsVisiblefillter(false);
                      }
                    }}
                  >
                    <span>
                      <i className="fa-solid fa-sliders"></i>
                    </span>
                    <p>Filter</p>
                  </div>
                  <FilterPopup
                    assignmentStatus={assignmentStatus}
                    score={score}
                    isVisiblefillter={isVisiblefillter}
                    handleApplyClick={handleApplyClick}
                    handleAssignmentStatusChange={handleAssignmentStatusChange}
                    fillterstatus={fillterstatus}
                    fillterScore={fillterScore}
                    handleScoreChange={handleScoreChange}
                  />
                </div>
              </div>
              <div className="LessonViewProgress-filder-tab-wrapper">
                <div
                  className="AssignmentViewProgress-filter-popup-wrapper"
                  ref={sortDropdownRef}
                >
                  <div
                    className="lessonviewprogress-filder-tab"
                    onClick={() => {
                      if (!isVisible) {
                        setIsVisible(true);
                        setIsVisiblefillter(false);
                      } else {
                        setIsVisible(false);
                      }
                    }}
                  >
                    <span>
                      {/* <img src={srot}/> */}
                      <i class="fa-solid fa-arrow-down-wide-short"></i>
                    </span>
                    <p>Sort</p>
                  </div>
                  <SortPopup
                    isVisible={isVisible}
                    handleSortClick={handleSortClick}
                    sortOption={sortOption}
                    onSortOptionChange={handleSortOptionChange}
                  />
                </div>
              </div>
            </div>
          </div>
           {/* <div className="submisson-enrollment-count"> */}
                      <p className="flex justify-end mt-4 mr-[14px] text-[13px] text-[#000]">
                        {`${location?.state?.submission_count}/${location?.state?.student_enrollment_count} Submissions Received`}
                      </p>
                    {/* </div> */}
          <div className="LessonViewProgress-table-container AssignmentViewProgress-table-container">
            <div className="mobile-cards-wrapper">
              {student_assignment_details && student_assignment_details.length > 0 ? (
                student_assignment_details.map((student, index) => (
                  <div key={student.id} className="mobile-student-card"
                    style={{ boxShadow: '0px 0px 8px 0px #0000001F' }}
                  >
                    {/* Name + Sr No */}
                    <div className="flex items-center gap-2">
                      <p className="text-[14px] font-semibold text-[#000] m-0">
                        {inial_value + index + 1}. {student.student_name}
                      </p>
                    </div>

                    {/* Practice Assignment Badge */}
                    {student.is_practice_assignment && (
                      <span className="text-[12px] text-[#0068ff] bg-[#e8f0ff] px-2 py-1 rounded-full w-fit">
                        Practice Assignment
                      </span>
                    )}

                    {/* Assignment Name */}
                    <div className="text-left">
                      <p className="text-[13px] text-[#000] m-0">
                        <span className="font-medium">Assignment Name : </span>
                        {student.assignment_name}
                      </p>
                    </div>

                    {/* Started At */}
                    <div className="text-left">
                      <p className="text-[13px] text-[#000] m-0">
                        <span className="font-medium">Started At : </span>
                        {Helper.formatDateTimeToLocal(student.started_date).date}{" "}
                        {Helper.formatDateTimeToLocal(student.started_date).time}
                      </p>
                    </div>

                    {/* Completed At */}
                    <div className="text-left">
                      <p className="text-[13px] text-[#000] m-0">
                        <span className="font-medium">Completed At : </span>
                        {student.completed_date
                          ? `${Helper.formatDateTimeToLocal(student.completed_date).date} ${Helper.formatDateTimeToLocal(student.completed_date).time}`
                          : "-"}
                      </p>
                    </div>

                    {/* Score */}
                    {student?.total_marks && student?.marks_awarded !== null && (
                      <div className="text-left">
                        <p className="text-[13px] text-[#000] m-0">
                          <span className="font-medium">Score : </span>
                          <span className="text-[#0068ff] font-semibold cursor-pointer"
                            onClick={(e) => { e.preventDefault(); toggleDropdown(index, 0, student); }}
                          >
                            {parseFloat(student?.marks_awarded ?? 0)}/{parseFloat(student?.total_marks ?? 0)}
                          </span>
                        </p>
                      </div>
                    )}

                    {/* View Analytics */}
                    {student.status !== "In progress" && student.completed_date && student?.submission_data?.length > 0 && (
                      <button type="button"
                        className="text-[#0068ff] text-[14px] font-medium underline text-center w-full bg-transparent border-none cursor-pointer"
                        onClick={() => {
                          const assignment_id = location?.state?.assignments
                            ? location?.state?.assignments[0]?.assignment_id
                            : location?.state?.assignment_id;
                          navigate(
                            `/course/${location.state.course.course_id}/lesson/${location.state.lesson.lesson_id}/assignment/${assignment_id}/analytics/${student.id}`,
                            { state: { student, selectedAssignment, courseType, myRole: location.state.myRole } }
                          );
                        }}
                      >
                        View Analytics
                      </button>
                    )}
                  </div>
                ))
              ) : (
                <p className="text-center text-[13px] text-[#888]">No data found</p>
              )}
            </div>
            <table className="desktop-table">
              <thead>
                <tr>
                  <th>Sr no.</th>
                  <th>Student Name</th>
                  <th>Assignment Name</th>
                  <th>Started At</th>
                  <th>Completed At</th>
                  {/* <th>Time Duration</th> */}
                  <th>Score</th>
                  {/* <th>Assignment Status</th> */}
                  {/* <th>Assignment Progress</th> */}
                  {/* <th>Score</th> */}
                  {/* <th>Student Chat</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {error === true ? (
                  <tr>
                    <td colSpan="8" className="tex-center">
                      {errormsg} No data found!!!!!!!!!!!!!!!!!!!!
                    </td>
                  </tr>
                ) : (
                  <>
                    {loading === true ? (
                      null
                    ) : (
                      // <tr>
                      //   <td colSpan="8" className="tex-center">
                      //     Loading ................
                      //   </td>
                      // </tr>
                      <>
                        {student_assignment_details &&
                          student_assignment_details.length > 0 ? (
                          student_assignment_details.map((student, index) => (
                            <tr key={student.id}>
                              <td>{inial_value + index + 1}</td>
                              {/* <td>
                                <div className="practice-assignment">
                                  <p>{student.student_name}</p>
                                  <span>Practice Assignment</span>
                                </div>
                              </td> */}
                              {/* <td>{student.student_name}</td> */}
                              <td>
                                <div className="practice-assignment">
                                  <p>{student.student_name}</p>
                                  {student.is_practice_assignment && <span>Practice Assignment</span>}
                                </div>
                              </td>
                              <td>{student.assignment_name}</td>
                              <td>
                                <div className="startedAt-time">
                                  <span>
                                    {Helper.formatDateTimeToLocal(student.started_date).date}
                                  </span>
                                  <span>
                                    {Helper.formatDateTimeToLocal(student.started_date).time}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="completedat-time">
                                  <span>
                                    {" "}
                                    {student.completed_date
                                      ? Helper.formatDateTimeToLocal(student.completed_date).date
                                      : "-"}
                                    {/* {
                                student.completed_date && student?.submission_data?.length > 0 ? (Helper.formatDateTime(
                                  student.started_date
                                ).date) : '-'
                              } */}
                                  </span>
                                  <span>
                                    {" "}
                                    {student.completed_date
                                      ? Helper.formatDateTimeToLocal(student.completed_date).time
                                      : ""}
                                    {/* {
                                student.completed_date && student?.submission_data?.length > 0 ? getcompletedTimer(student.submission_data, Helper.formatDateTime(
                                  student.started_date
                                ).time) : ''
                              } */}
                                  </span>
                                  {/* <img src={student_grade_flage} alt="" /> */}
                                </div>
                              </td>
                              {/* <td>
                                1 min 00s
                              </td> */}
                              {/* <td>
                        <div
                          className={`LessonViewProgress-student-status ${Helper.getClassNameByStatus(
                            student.status
                          )}`}
                        >
                          {student.status}
                        </div>
                      </td> */}
                              {/* <td>
                        <div className="progress">
                          <div
                            className="progress-bar"
                            style={{ width: `20%` }}
                          ></div>
                        </div>
                      </td> */}
                              {student?.total_marks &&
                                student?.marks_awarded !== null ? (
                                <td
                                  style={{
                                    cursor: "pointer",
                                    color: "#0068ff",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleDropdown(
                                      index,
                                      0,
                                      student
                                    );
                                  }}
                                >
                                  <h2 className="student-score">
                                    {student?.marks_awarded
                                      ? student?.marks_awarded
                                        ? parseFloat(student?.marks_awarded)
                                        : 0
                                      : 0}
                                    /
                                    {student?.total_marks
                                      ? student?.total_marks
                                        ? parseFloat(student?.total_marks)
                                        : 0
                                      : 0}
                                  </h2>
                                </td>
                              ) : (
                                <td>-</td>
                              )}

                              {/* <td>
                            <div className="LessonViewProgress-student-chat" onClick={(e) => {
                                      e.preventDefault();
                                      navigate(`/dashboard/messageschat/`, {
                                        state: {
                                          studentName: student.student_name, // Passing student name
                                          studentProfile: student.student_profile_pic,
                                          studentId : student.student_user_id,
                                          teacherId : student.teacher_user_id
                                        }
                                      });
                                    }}>
                                    <a> */}
                              {/* ND */}
                              {/* <img src={student.student_profile_pic} className="profile-pic-image"/>
                                  </a>
                                    <img src={massege} alt="" />
                            </div>
                          </td> */}
                              <td>
                                {student.status !== "In progress" &&
                                  student.completed_date &&
                                  student?.submission_data?.length > 0 ? (
                                  <div className="view_analytics_btn">
                                    <Button
                                      variant="underline"
                                      onClick={() => {
                                        const assignment_id = location?.state
                                          ?.assignments
                                          ? location?.state?.assignments[0]
                                            ?.assignment_id
                                          : location?.state?.assignment_id;
                                        navigate(
                                          `/course/${location.state.course.course_id}/lesson/${location.state.lesson.lesson_id}/assignment/${assignment_id}/analytics/${student.id}`,
                                          {
                                            state: {
                                              student: student,
                                              selectedAssignment: selectedAssignment,
                                              courseType: courseType,
                                              myRole: location.state.myRole
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      View analytics
                                    </Button>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
            <div>
              {loading === true &&
                <div className="spinner-folder">
                  <LoadingComponent loading_text="Educating the Future, Loading Now." />
                </div>
              }
            </div>

            <br />
            <Grid xs={12} container justifyContent={"center"}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                hideNextButton={nextUrl === null || currentPage === totalPages} // Disable if no next URL and on the last page
                hidePrevButton={prevUrl === null || currentPage === 1} // Hide if no previous URL and on the first page
              />
            </Grid>
          </div>
          {showdownlodefile && (
            <div className="Download-File-popup-wrappper">
              <div className="Download-File-popup-container" data-aos="zoom-in">
                <div className="download-popup">
                  <h2>Download File as</h2>
                  <button className="close-btn" onClick={toggledownlodefile}>
                    ×
                  </button>
                  <div className="input-section">
                    <label>
                      File Name{" "}
                      <input
                        type="text"
                        name="namefiletodnld"
                        placeholder="Enter File Name"
                        value={fileNameDownload}
                        onChange={handleFileNameChange}
                      />
                      {fileNameError && (
                        <p style={{ color: "red" }}>{fileNameError}</p>
                      )}
                    </label>
                  </div>
                  <div className="button-section">
                    {/* <button className="pdf-btn">PDF (.pdf)</button>
              <span>Or</span> */}
                    <button
                      className="spreadsheet-btn"
                      onClick={download_as_excel}
                    >
                      Spreadsheet (.xlsx)
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showDropdown && (
            <div className="AssignmentViewProgress-mock-test-wrapper">
              <div
                className="AssignmentViewProgress-mock-test-container max-h-[90vh] overflow-y-auto"
                data-aos="zoom-in"
              >
                {
                  <QuestionNew
                    assignment={
                      analyticDetailsData?.student_answers_json[assignmentIndex]
                    }
                    ai_evaluation_json={analyticDetailsData?.ai_evaluation_json}
                    index={assignmentIndex}
                    arrayIndex={arrayIndex}
                    currentStep={assignmentIndex + 1}
                    totalSteps={
                      analyticDetailsData?.student_answers_json.length
                    }
                    handleNext={() =>
                      assignmentIndex <
                        analyticDetailsData?.student_answers_json.length - 1
                        ? setAssignmentIndex((p) => p + 1)
                        : null
                    }
                    handleBack={() => setAssignmentIndex((p) => p - 1)}
                    isLast={
                      assignmentIndex ===
                      analyticDetailsData?.student_answers_json.length - 1
                    }
                    isFirst={assignmentIndex === 0}
                    close={
                      <span
                        onClick={toggleDropdownclose}
                        className="AssignmentViewProgress-mock-test-close-btn"
                      >
                        <i className="fa-solid fa-x"></i>
                      </span>
                    }
                    questions={
                      analyticDetailsData?.ai_evaluation_json?.questions
                    }
                    // assignmentType={analyticDetailsData?.assignment_analytics && analyticDetailsData?.assignment_analytics[0]?.assignment_type}
                    assignmentType={analyticDetailsData?.student_answers_json && analyticDetailsData?.student_answers_json[assignmentIndex].type}
                    courseType={courseType}
                    handleGetTeacherAnswerAssignmentAnalytics={handleGetTeacherAnswerAssignmentAnalytics}
                    analyticDetailsData={analyticDetailsData}
                    setAnalyticDetailsData={setAnalyticDetailsData}
                    is_practice_assignment={student_assignment_details[viewAssignmentIndex].practice_assignment_id}
                    course_id={course_id}
                    myRole={location.state.myRole}
                    TeacherMyCourse={TeacherMyCourse}
                    currentAssignment={analyticDetailsData?.student_answers_json[assignmentIndex]}
                  />
                }
              </div>
            </div>
          )}
          {/* <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default AssignmentViewProgress;